import * as React from 'react';

function isTypingTarget(target: EventTarget | null): boolean {
	if (!(target instanceof HTMLElement)) {
		return false;
	}
	const tag = target.tagName;
	return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable;
}

/** Page-level single-key shortcuts that stay out of the way while the user is typing somewhere. */
export function useActionItemsKeyboardShortcuts({
	enabled,
	bindings,
}: {
	enabled: boolean;
	bindings: Record<string, (event: KeyboardEvent) => void>;
}) {
	const bindingsRef = React.useRef(bindings);
	React.useLayoutEffect(() => {
		bindingsRef.current = bindings;
	});

	React.useEffect(() => {
		if (!enabled) {
			return;
		}
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.metaKey || event.ctrlKey || event.altKey || isTypingTarget(event.target)) {
				return;
			}
			const handler = bindingsRef.current[event.key];
			if (handler) {
				event.preventDefault();
				handler(event);
			}
		};
		window.addEventListener('keydown', onKeyDown);
		return () => window.removeEventListener('keydown', onKeyDown);
	}, [enabled]);
}
